/*
  Keeps the customer's machine in the cart note so it lands in the Shopify
  order's Notes with no app or server involved. The note is stored as
  "<customer's own note>\n\n<machine block>"; only the customer's part is ever
  shown in the order-note textarea.

  The header line must match ORDER_NOTE_MACHINE_HEADER in
  CRM/src/lib/shopify/order-machine.ts, which skips orders that already have it.

  ES5 only: loaded on every page and called from machines.js.
*/
(function () {
  var HEADER = 'Customer machine (from cart):';
  var queue = Promise.resolve();

  function customerPart(note) {
    note = note || '';
    var i = note.indexOf(HEADER);
    return (i === -1 ? note : note.slice(0, i)).replace(/\s+$/, '');
  }

  function machinePart(note) {
    note = note || '';
    var i = note.indexOf(HEADER);
    return i === -1 ? '' : note.slice(i).replace(/\s+$/, '');
  }

  function machineBlock(attributes) {
    var make = (attributes['Machine Make'] || '').trim();
    var model = (attributes['Machine Model'] || '').trim();
    var highFlow = attributes['High Flow'] === 'Yes';
    if (!make && !model && !highFlow) return '';

    var lines = [HEADER];
    if (make) lines.push('Make: ' + make);
    if (model) lines.push('Model: ' + model);
    lines.push('High flow: ' + (highFlow ? 'Yes' : 'No'));
    return lines.join('\n');
  }

  function join(customer, block) {
    return [customer, block].filter(Boolean).join('\n\n');
  }

  function hiddenInputs() {
    return document.querySelectorAll('[data-cart-full-note]');
  }

  function setHiddenNote(note) {
    var inputs = hiddenInputs();
    for (var i = 0; i < inputs.length; i++) inputs[i].value = note;
  }

  function composeFrom(base, opts) {
    var customer = typeof opts.customerNote === 'string' ? opts.customerNote : customerPart(base);
    var block = opts.attributes ? machineBlock(opts.attributes) : machinePart(base);
    return join(customer, block);
  }

  // Synchronous update of the hidden note inputs, so a Checkout click that
  // beats the debounced save still posts the right note with the cart form.
  function preview(opts) {
    var inputs = hiddenInputs();
    if (!inputs.length) return;
    setHiddenNote(composeFrom(inputs[0].value, opts));
  }

  // opts.attributes: full set of machine attributes to save (optional)
  // opts.customerNote: the customer's own note text (optional)
  function save(opts) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var updateUrl = (window.theme && theme.routes && theme.routes.cartUpdate) || root + 'cart/update';
    var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };

    queue = queue
      .then(function () {
        return fetch(root + 'cart.js', { headers: headers });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var attributes = {};
        var key;
        var current = cart.attributes || {};
        for (key in current) attributes[key] = current[key];
        if (opts.attributes) {
          for (key in opts.attributes) attributes[key] = opts.attributes[key];
        }

        var customer = typeof opts.customerNote === 'string' ? opts.customerNote : customerPart(cart.note);
        var note = join(customer, machineBlock(attributes));
        setHiddenNote(note);

        var body = { note: note };
        if (opts.attributes) body.attributes = opts.attributes;
        return fetch(updateUrl, { method: 'POST', headers: headers, body: JSON.stringify(body) });
      })
      ['catch'](function () {});
    return queue;
  }

  window.CartMachineNote = {
    HEADER: HEADER,
    customerPart: customerPart,
    preview: preview,
    save: save
  };
})();
